// src/icons/WellnessIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function WellnessIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 21 20",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M10.0125 20C8.81101 19.8665 7.61368 19.5202 6.42053 18.9612C5.22737 18.4022 4.15519 17.6262 3.204 16.6333C2.25282 15.6404 1.48102 14.4139 0.888611 12.9537C0.296204 11.4935 0 9.79558 0 7.85982V6.90864H0.951189C1.83563 6.90864 2.77847 7.07968 3.77972 7.42178C4.78098 7.76387 5.66542 8.20192 6.43304 8.73592C6.56654 7.23404 6.96704 5.68627 7.63454 4.09262C8.30204 2.49896 9.0947 1.13475 10.0125 0C10.9303 1.13475 11.723 2.49896 12.3905 4.09262C13.058 5.68627 13.4585 7.23404 13.592 8.73592C14.3596 8.23529 15.2441 7.80559 16.2453 7.44681C17.2466 7.08803 18.1894 6.90864 19.0738 6.90864H20.025V7.85982C20.025 9.79558 19.7288 11.4935 19.1364 12.9537C18.544 14.4139 17.7722 15.6404 16.821 16.6333C15.8698 17.6262 14.7977 18.4022 13.6045 18.9612C12.4113 19.5202 11.214 19.8665 10.0125 20ZM10.2128 18.4731C10.0292 15.3692 9.13225 13.0163 7.5219 11.4143C5.91156 9.81227 3.91323 8.81936 1.52691 8.43554C1.74385 11.6562 2.68252 14.0592 4.34293 15.6446C6.00334 17.2299 7.95995 18.1727 10.2128 18.4731ZM9.98748 12.3404C10.2211 11.9066 10.5423 11.4393 10.9512 10.9387C11.36 10.438 11.7564 10.0209 12.1402 9.68711C12.2236 8.55236 12.0567 7.40092 11.6395 6.23279C11.2224 5.06466 10.68 3.85482 10.0125 2.60325C9.34501 3.85482 8.80267 5.06466 8.38548 6.23279C7.96829 7.40092 7.80142 8.55236 7.88486 9.68711C8.26867 10.0209 8.65665 10.438 9.04881 10.9387C9.44097 11.4393 9.75386 11.9066 9.98748 12.3404ZM11.7146 18.0476C12.499 17.7639 13.2791 17.3884 14.0551 16.9212C14.831 16.4539 15.5319 15.8448 16.1577 15.0939C16.7835 14.3429 17.3091 13.4209 17.7347 12.3279C18.1602 11.2349 18.4147 9.93742 18.4981 8.43554C16.7292 8.71923 15.169 9.34919 13.8173 10.3254C12.4656 11.3016 11.4727 12.5073 10.8385 13.9424C11.0388 14.5766 11.214 15.2149 11.3642 15.8573C11.5144 16.4998 11.6312 17.2299 11.7146 18.0476Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  WellnessIcon
};
//# sourceMappingURL=WellnessIcon.mjs.map